import { Component, OnInit, ViewEncapsulation, Input, Output, EventEmitter } from '@angular/core';
import { TransferCertificatePreviewServices } from './transfer-certificate-preview.service';
import { firstValueFrom } from 'rxjs';
import * as transferCertificatePreviewStrings from "../stringFiles/transferCertificatePreview.json";
import { TranslateService } from '@ngx-translate/core';

declare var $: any;
declare var customToastr: any;

@Component({
  selector: 'app-transfer-certificate-preview',
  templateUrl: './transfer-certificate-preview.component.html',
  styleUrls: [
    './../../assets/css/theme-default/bootstrap.css',
    './../../assets/css/theme-default/materialadmin.css',
    './../../assets/css/theme-default/font-awesome.min.css',
    './../../assets/css/theme-default/libs/bootstrap-datepicker/datepicker3.css',
    './../../assets/css/theme-default/libs/DataTables/jquery.dataTables.css',
    './../../assets/css/theme-default/libs/DataTables/extensions/dataTables.colVis.css',
    './../../assets/css/theme-default/material-design-iconic-font.min.css',
    './../../assets/css/theme-default/libs/DataTables/extensions/dataTables.tableTools.css',
    './../../assets/css/theme-default/libs/bootstrap-tagsinput/bootstrap-tagsinput.css',
    './../../assets/css/theme-default/libs/nestable/nestable.css',
    './../../assets/css/theme-default/libs/jquery-ui/jquery-ui-theme.css',
    './../../css/timepicker.css',
    './transfer-certificate-preview.component.css'
  ],
  encapsulation: ViewEncapsulation.None,
  providers: [TransferCertificatePreviewServices]
})
export class TransferCertificatePreviewComponent implements OnInit {
  @Input() selectedJobId: any;

  @Output() backArrowClicked = new EventEmitter<void>();

  onBackArrowClick() {
    this.backArrowClicked.emit();
  }

  transferCertificatePreviewStrings: any = transferCertificatePreviewStrings;
  isComponentLoading: Boolean = false;
  tcDetailsForParticularJob: any = [];
  filteredTcDetailsForParticularJob: any = [];
  serviceId: String = "";
  searchValue: String = "";
  searchDebounceValue: any;
  isEmailModalOpen: boolean = false;
  email: String = '';
  emailList: String[] = [];
  emailError: Boolean = false;
  isEmailSending: Boolean = false;
  zipFileUrl: any = "";
  showParticularTcPreview: boolean = false;
  selectedTcImageUrl: String = "";
  selectedTcPdfUrl: any = "";
  currentIndex: any = 0;
  isEmailAddButtonDisabled: Boolean = false;
  isEmailRemoveButtonDisabled: Boolean = false;

  constructor(private TransferCertificatePreviewServices: TransferCertificatePreviewServices, private translate: TranslateService) { }

  handelOnBlurSearch(): void {
    if (!this.searchValue) {
      this.filteredTcDetailsForParticularJob = this.tcDetailsForParticularJob;
    }
  }

  filterParticularStudentTc() {
    if (this.searchValue.trim()) {
      const searchLower = this.searchValue.trim().toLowerCase();
      clearTimeout(this.searchDebounceValue);
      this.searchDebounceValue = setTimeout(() => {
        this.filteredTcDetailsForParticularJob = this.tcDetailsForParticularJob.filter((item:
          {
            isLatestTc: Boolean,
            isDuplicate: Boolean,
            studentName: String,
            tcImageUrl: String,
            documentUrl: String,
            pkJobStudentDetailId: any
          }) => {
          const studentName = item.studentName.toLowerCase();
          return studentName.includes(searchLower)
        });
      }, 800)
    } else {
      clearTimeout(this.searchDebounceValue);
      this.filteredTcDetailsForParticularJob = this.tcDetailsForParticularJob;
    }
  }

  openEmailModal() {
    this.isEmailModalOpen = true;
  }

  closeEmailModal() {
    this.isEmailModalOpen = false;
    this.emailList = [];
    this.email = '';
    this.emailError = false;
    this.isEmailAddButtonDisabled = false;
    this.isEmailRemoveButtonDisabled = false;
  }

  validateEmail(lowerCasedEmail) {
    if (lowerCasedEmail.trim()) {
      const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      this.emailError = !emailPattern.test(lowerCasedEmail);
    } else {
      this.emailError = true
    }
  }

  addEmail() {
    const lowerCasedEmail = this.email.toLowerCase();
    this.validateEmail(lowerCasedEmail);
    if (!this.emailError) {
      if (!this.emailList.includes(lowerCasedEmail)) {
        this.emailList.push(lowerCasedEmail);
      }
      this.email = '';
    }
  }

  removeEmail(removeEmail: string) {
    this.emailList = this.emailList.filter(email => email !== removeEmail);
  }

  async downloadZipFile() {
    if (this.zipFileUrl) {
      var link = document.createElement('a');
      link.href = this.zipFileUrl;
      link.download = this.zipFileUrl.split('/').pop() || this.serviceId + this.transferCertificatePreviewStrings.labelPdfExtension;
      link.click();
    } else {
      const zipDownloadIssueTranslations = await firstValueFrom(this.translate.get('zipDownloadIssue'));
      customToastr(zipDownloadIssueTranslations, this.transferCertificatePreviewStrings.errorCode);
    }
  }

  async viewParticularTcPreview(particularTcDetail: any) {
    if (particularTcDetail && particularTcDetail.tcImageUrl) {
      this.selectedTcImageUrl = particularTcDetail.tcImageUrl ? particularTcDetail.tcImageUrl : "";
      this.selectedTcPdfUrl = particularTcDetail.documentUrl ? particularTcDetail.documentUrl : "";
      this.showParticularTcPreview = true;
      this.currentIndex = this.filteredTcDetailsForParticularJob.findIndex(
        item => item.pkJobStudentDetailId == particularTcDetail.pkJobStudentDetailId
      );
    } else {
      const tcPreviewIssueTranslations = await firstValueFrom(this.translate.get('tcPreviewIssue'));
      customToastr(tcPreviewIssueTranslations, this.transferCertificatePreviewStrings.errorCode);
    }
  }

  closeParticularTcPreviewPopup(event: MouseEvent): void {
    this.showParticularTcPreview = false;
  }

  async downloadPdfFile(fileUrl: any) {
    if (fileUrl) {
      fetch(fileUrl)
        .then(response => response.blob())
        .then(blob => {
          const link = document.createElement('a');
          const url = URL.createObjectURL(blob);
          link.href = url;
          link.download = fileUrl.split('/').pop() || this.transferCertificatePreviewStrings.defaultTcPdfName;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          URL.revokeObjectURL(url);
        })
        .catch(async error => {
          const pdfDownloadIssueTranslations = await firstValueFrom(this.translate.get('pdfDownloadIssue'));
          customToastr(pdfDownloadIssueTranslations, this.transferCertificatePreviewStrings.errorCode)
        }
      );

        
    } else {
      const pdfDownloadIssueTranslations = await firstValueFrom(this.translate.get('pdfDownloadIssue'));
      customToastr(pdfDownloadIssueTranslations, this.transferCertificatePreviewStrings.errorCode);
    }
  }

  navigateTc(direction: any) {
    const newIndex = this.currentIndex + direction;
    if (newIndex >= 0 && newIndex < this.filteredTcDetailsForParticularJob.length) {
      this.currentIndex = newIndex;
      this.selectedTcPdfUrl = this.filteredTcDetailsForParticularJob[newIndex].documentUrl ? this.filteredTcDetailsForParticularJob[newIndex].documentUrl : "";
      this.selectedTcImageUrl = this.filteredTcDetailsForParticularJob[newIndex].tcImageUrl ? this.filteredTcDetailsForParticularJob[newIndex].tcImageUrl : "";
    }
  }

  async printTc(pdfUrl: string): Promise<void> {
    if (pdfUrl) {
      fetch(pdfUrl)
        .then(async response => {
          if (!response.ok) {
            const pdfPrintIssueTranslations = await firstValueFrom(this.translate.get('pdfPrintIssue'));
            customToastr(pdfPrintIssueTranslations, this.transferCertificatePreviewStrings.errorCode);
          }
          return response.blob();
        })
        .then(blob => {
          const blobUrl = URL.createObjectURL(blob);
          const iframe = document.createElement('iframe');
          iframe.style.position = 'absolute';
          iframe.style.width = '0';
          iframe.style.height = '0';
          iframe.style.border = 'none';
          iframe.src = blobUrl;
          document.body.appendChild(iframe);
          iframe.onload = () => {
            iframe.contentWindow?.print();
          };
        })
        .catch(async error => {
          const pdfPrintIssueTranslations = await firstValueFrom(this.translate.get('pdfPrintIssue'));
          customToastr(pdfPrintIssueTranslations, this.transferCertificatePreviewStrings.errorCode);
        });
    } else {
      const pdfPrintIssueTranslations = await firstValueFrom(this.translate.get('pdfPrintIssue'));
      customToastr(pdfPrintIssueTranslations, this.transferCertificatePreviewStrings.errorCode);
    }
  }

  async getAllTcForParticularJob() {
    try {
      this.isComponentLoading = true;
      const response = await firstValueFrom(this.TransferCertificatePreviewServices.getAllTcForParticularServiceApi(this.selectedJobId));
      const responseDetails = response as any;
      if (responseDetails && responseDetails.status) {
        if (responseDetails.body && responseDetails.body.tcPreviewDetails) {
          this.serviceId = responseDetails.body.tcPreviewDetails.serviceId ? responseDetails.body.tcPreviewDetails.serviceId : '';
          this.zipFileUrl = responseDetails.body.tcPreviewDetails.zipFileUrl ? responseDetails.body.tcPreviewDetails.zipFileUrl : '';
          this.tcDetailsForParticularJob = responseDetails.body.tcPreviewDetails.studentsTcData ? responseDetails.body.tcPreviewDetails.studentsTcData : [];
          this.filteredTcDetailsForParticularJob = this.tcDetailsForParticularJob;
        }
      } else {
        this.serviceId = "";
        this.zipFileUrl = "";
        this.tcDetailsForParticularJob = [];
        this.filteredTcDetailsForParticularJob = [];
        if (responseDetails.message) {
          customToastr(responseDetails.message, this.transferCertificatePreviewStrings.errorCode);
        } else {
          const errorMessageTranslations = await firstValueFrom(this.translate.get('errorMessage'));
          customToastr(errorMessageTranslations, this.transferCertificatePreviewStrings.errorCode);
        }
      }
      this.isComponentLoading = false;
    } catch (error) {
      this.serviceId = "";
      this.zipFileUrl = "";
      this.tcDetailsForParticularJob = [];
      this.filteredTcDetailsForParticularJob = [];
      const errorMessageTranslations = await firstValueFrom(this.translate.get('errorMessage'));
      customToastr(error
        ? error.error
          ? error.error.message
          : errorMessageTranslations
        : errorMessageTranslations,
        this.transferCertificatePreviewStrings.errorCode);
      this.isComponentLoading = false;
    }
  }

  async sendTcOverEmail() {
    try {
      if (this.emailList.length == 0 || this.emailError) {
        this.emailError = true;
      } else {
        this.isEmailSending = true;
        this.isEmailAddButtonDisabled = true;
        this.isEmailRemoveButtonDisabled = true;
        const body = {
          lang: "en",
          jobDetailId: this.selectedJobId,
          emailIdList: this.emailList
        }
        const response = await firstValueFrom(this.TransferCertificatePreviewServices.emailTransferCertificate(body));
        const responseDetails = response as any;
        if (responseDetails && responseDetails.status) {
          if (responseDetails.body && responseDetails.body.message) {
            customToastr(responseDetails.body.message, this.transferCertificatePreviewStrings.successCode);
          } else {
            const errorMessageTranslations = await firstValueFrom(this.translate.get('errorMessage'));
            customToastr(errorMessageTranslations, this.transferCertificatePreviewStrings.errorCode);
          }
        } else {
          if (responseDetails.message) {
            customToastr(responseDetails.message, this.transferCertificatePreviewStrings.errorCode);
          } else {
            const errorMessageTranslations = await firstValueFrom(this.translate.get('errorMessage'));
            customToastr(errorMessageTranslations, this.transferCertificatePreviewStrings.errorCode);
          }
        }
        this.closeEmailModal();
        this.isEmailSending = false;
      }
    } catch (error) {
      const errorMessageTranslations = await firstValueFrom(this.translate.get('errorMessage'));
      customToastr(error
        ? error.error
          ? error.error.message
          : errorMessageTranslations
        : errorMessageTranslations,
        this.transferCertificatePreviewStrings.errorCode);
      this.isEmailSending = false;
    }
  }

  ngOnInit() {
    $(".after").empty();
    $("#device-breakpoints").remove();
    $(".after").append(
      "<script>function customToastr(message,type){toastr.options.hideDuration = 0;toastr.clear();" +
      "toastr.options.closeButton = true;toastr.options.progressBar = false;toastr.options.debug = false;" +
      "toastr.options.positionClass = 'toast-top-right';toastr.options.showDuration = 330;toastr.options.hideDuration = 330;" +
      "toastr.options.timeOut = 5000;toastr.options.extendedTimeOut = 1000;toastr.options.showEasing = 'swing';" +
      "toastr.options.hideEasing = 'swing';toastr.options.showMethod = 'slideDown';toastr.options.hideMethod = 'slideUp';" +
      "toastr[type](message, '');return 0;} </" +
      "script>"
    );
    this.getAllTcForParticularJob()
  }
}